import * as React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/cn";

export const PageLoading: React.FC<{ label?: string }> = ({
  label = "Loading…",
}) => (
  <div
    role="status"
    aria-live="polite"
    className="flex items-center gap-2 text-sm text-muted-foreground"
    data-testid="page-loading"
  >
    <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

export const EmptyState: React.FC<{
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}> = ({ title, description, action, className }) => (
  <div
    className={cn(
      "flex flex-col items-start gap-2 rounded-lg border border-dashed bg-card p-6 text-left",
      className,
    )}
    data-testid="empty-state"
  >
    <h3 className="text-base font-semibold">{title}</h3>
    {description && (
      <p className="text-sm text-muted-foreground">{description}</p>
    )}
    {action}
  </div>
);

export const ErrorMessage: React.FC<{
  message: string;
  className?: string;
}> = ({ message, className }) => (
  <p
    role="alert"
    className={cn("text-sm text-destructive", className)}
    data-testid="error-message"
  >
    {message}
  </p>
);
